import React, { useEffect } from 'react'
import useSWR from 'swr'

import TrailAnimation from '@/components/common/trail-animation'
import { Sound, Album } from '../../components/app/media'
import { getLatest } from '../../data/api/feed'

const PER_PAGE = 20

// const getKey = (item) => (item.type === 'sound' ? item.sound.id : item.album.id)
const loadLatest = async (page: number) => {
  const result = await getLatest(PER_PAGE, page + 1)
  return result
}

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  latest: Array<any>
  page: number
  noMore: () => void
  loaded: () => void
}

const Latest = ({ latest, page, noMore, loaded }: Props) => {
  const { data: latestData } = useSWR([ '/feed/latest/', page ], () => loadLatest(page), {
    fallbackData: latest,
  })

  useEffect(() => {
    if (!latestData || latestData.error) {
      return
    }
    loaded()
    if (latestData.length === 0) {
      noMore()
    }
  }, [ latestData ])

  if (!latestData || latestData.error) {
    return null
  }

  return (
    <>
      {latestData.map((media) => (
        <TrailAnimation key={`fetature-${page}-${media.id}`}>
          {media.type === 'sound' && !!media.sound && (
            <Sound sound={media.sound} />
          )}
          {media.type === 'album' && !!media.album && (
            <Album album={media.album} />
          )}
        </TrailAnimation>
      ))}
    </>
  )
}

export default Latest
